import { apiClient } from 'helpers/api';

import type {
  PublicCompanyAndUserInfo,
  PublicPasswordToCreate,
  ResetPasswordRequest
} from './models/mainservice';

export default {
  createPassword: (values: PublicPasswordToCreate) => {
    return apiClient.put<PublicCompanyAndUserInfo>(`/public/password/create`, values);
  },
  recoverPassword: (values: PublicPasswordToCreate) => {
    return apiClient.put<PublicCompanyAndUserInfo>(`/public/password/recover`, values);
  },
  requestPasswordRecovery: (values: ResetPasswordRequest) => {
    return apiClient.put<undefined>(`/public/password/reset`, values);
  }
};
